<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		{{title}}
		<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square"></div>
	</div>
</div>

<div id="{{objectIdForCollapsingWidget}}" *ngIf="!toggled" class="jmWidgetPadding">
	<div class="w-100" style="height:6%">
		<div class="jmPageTitle">
			{{title}}
			<div (click)="toggleCollapse()" *ngIf="showMinimize" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="margin-top:10px;"></div>
		</div>
	</div>
	<div class="row">
		<div [ngClass]="(lgView===true)?'col-6':'col-12'">
			<div>
				<span>Average Annual Cost</span>
				<i class="jmInfoCircle" style="margin-left:5px" (click)="displayInfoWrapper('Average Annual Cost','The average annual net price for federal financial aid recipients, after aid from the school, state, or federal government. For public schools, this is only the average cost for in-state students.', 'cost')"></i>
			</div>
			<figure class="meter cost-meter">
				<picc-meter [attr.max]="data.CollegeCost.Max" [attr.average]="data.CollegeCost.Average" [attr.national-average]="data.CollegeCost.NationalAverage">
					<div class="picc-meter-bar" [ngStyle]="{'height':data.CollegeCost.AveragePcnt+'%'}"></div>
					<div class="picc-meter-line" [ngStyle]="{'bottom':data.CollegeCost.NationalAveragePcnt+'%'}"><span class="label">${{appUtility.toCommaNumber(data.CollegeCost.NationalAverage)}}</span></div>
				</picc-meter>
				<figcaption><span style="font-size:15px;" *ngIf="data.CollegeCost.Average>0">${{appUtility.toCommaNumber(data.CollegeCost.Average)}}</span><span *ngIf="data.CollegeCost.Average==0">Data not available</span></figcaption>
			</figure>
			<div style="font-size:15px;">---- National Average</div>
		</div>
		<div [ngClass]="(lgView===true)?'col-6':'col-12 spacer-bottom'">
			<div [ngClass]="(lgView===true)?'spacer-bottom-small':'spacer-top-large spacer-bottom'">By Family Income</div>
			<div [ngClass]="(lgView===true)?'family-income-align spacer-bottom':'spacer-bottom-large'">
				Depending on the federal, state, or institutional grant aid available, students in your income bracket may pay more or less than the overall average costs.
			</div>
			<div style="margin-bottom:10px;">Average cost by family income</div>
			<table style="width:100%;">
				<tr><td class="family-income-header" style="font-weight:bold;"><div>Family Income</div></td>
					<td class="family-income-header" style="font-weight:bold;">Average Cost</td>
				</tr>
				<tr *ngFor="let cost of data.IncomeCost">
					<td class="family-income-row">{{cost.Income}}</td>
					<td class="family-income-row">{{appUtility.toDollar(cost.AverageCost, true)}}</td>
				</tr>
			</table>
		</div>
	</div>
</div>
